import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTeamStore } from '../../lib/store/teamStore';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import Alert from '../../components/common/Alert';

const TeamSetupPage: React.FC = () => {
  const { teamId } = useParams<{ teamId: string }>();
  const navigate = useNavigate();
  const { currentTeam, isLoading, error, setCurrentTeam } = useTeamStore();
  
  console.log('TeamSetupPage: Rendering with params', { teamId, currentTeam, isLoading, error });
  
  useEffect(() => {
    if (teamId) {
      console.log('TeamSetupPage: Setting current team', teamId);
      setCurrentTeam(teamId);
    }
  }, [teamId, setCurrentTeam]);
  
  if (isLoading) {
    console.log('TeamSetupPage: Loading state');
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin h-8 w-8 border-t-2 border-b-2 border-primary rounded-full"></div>
      </div>
    );
  }
  
  if (error) {
    console.log('TeamSetupPage: Error state', error);
    return (
      <Alert variant="error" className="my-4">
        {error}
      </Alert>
    );
  }
  
  if (!currentTeam) {
    console.log('TeamSetupPage: No current team found');
    return (
      <Alert variant="error" className="my-4">
        Team not found
      </Alert>
    );
  }
  
  console.log('TeamSetupPage: Rendering setup page for team', currentTeam);
  
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Card className="p-8 max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2">Team Created Successfully!</h1>
          <p className="text-gray-600">
            Your team "{currentTeam.name}" has been created. Now you can invite members and continue setting up your team.
          </p>
        </div>
        
        <div className="space-y-6">
          <div className="p-4 border rounded-lg bg-gray-50">
            <h3 className="font-medium mb-2">Team Settings</h3>
            <div className="grid grid-cols-2 gap-2 text-sm">
              <div className="text-gray-500">Day Providers Required:</div>
              <div>{currentTeam.day_providers_required}</div>
              <div className="text-gray-500">Night Providers Required:</div>
              <div>{currentTeam.night_providers_required}</div>
              <div className="text-gray-500">Shifts Per Provider:</div>
              <div>{currentTeam.shifts_per_provider}</div>
              <div className="text-gray-500">Scheduling Period:</div>
              <div>{currentTeam.scheduling_period_days} days</div>
              <div className="text-gray-500">Max Consecutive Shifts:</div>
              <div>{currentTeam.max_consecutive_shifts}</div>
              <div className="text-gray-500">Minimum Rest Hours:</div>
              <div>{currentTeam.min_rest_hours}</div>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="outline"
              onClick={() => navigate('/')}
            >
              Go To Dashboard
            </Button>
            <Button
              variant="primary"
              onClick={() => navigate(`/teams/${currentTeam.id}/members/invite`)}
            >
              Invite Team Members
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default TeamSetupPage; 